import { makeStyles } from '@mui/styles';
const simpleButtonStyles = makeStyles(theme => ({
    button: {
        maxWidth: 'fit-content',
        padding: '7px 40px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:before': {
            content: '" "',
            width: '100%',
            height: 'calc(100% + 2px)',
            opacity: 0,
            position: 'absolute',
            top: -1,
            left: 0,
            display: 'block',
            pointerEvents: 'none',
            transform: 'skew(-30deg) translate3d(100%, 0, 0)',
            backgroundColor: 'hsla(0, 0%, 60%, .5)',
        },
        '&:hover:before': {
            animation: '$anim_button_hover 0.75s ease forwards',
        },
    },
    contained: {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.primary.main,
    },
    disable: {
        opacity: '.1',
    },
    outlined: {
        backgroundColor: theme.palette.common.white,
    },
    label: {
        padding: '6px 0',
    },
    '@keyframes anim_button_hover': {
        '0%': {
            width: '100%',
            opacity: 0,
            transform: 'skew(-30deg) translate3d(100%, 0, 0)',
        },
        '50%': {
            width: '300%',
            opacity: 1,
            transform: 'skew(-30deg) translateZ(0)',
        },
        '100%': {
            width: '100%',
            opacity: 0,
            transform: 'skew(-30deg) translate3d(-100%, 0, 0)',
        },
    },
}), { name: 'Common_SimpleButton' });
export default simpleButtonStyles;
//# sourceMappingURL=simpleButton.styles.js.map